import { Box, Card, Typography, styled } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

export const StyledStatsGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "12px",
  alignItems: "stretch",
  "@media (min-width: 600px)": {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  "@media (min-width: 1302px)": {
    gridTemplateColumns: "repeat(5, 1fr)",
  },
});

export const StyledCompactStatsGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "12px",
  alignItems: "stretch",
  "@media (min-width: 600px)": {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  "@media (min-width: 1302px)": {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
});

export const StyledDashboardCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.custom.orderCards,
  borderRadius: 16,
  padding: "15px",
  width: "100%",
  height: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  color: theme.palette.custom.white,
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
}));

export const StyledCompactCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.custom.orderCards,
  borderRadius: 16,
  padding: "15px 35px",
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  overflow: "hidden",
  height: "170px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  color: theme.palette.custom.white,
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  gap: "15px",
}));

export const StyledDashboardIconContainer = styled(Box)({
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const StyledDashboardCompactIconContainer = styled(Box)({
  borderRadius: "50%",
  width:"33px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const StyledDashboardTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  marginTop: 8,
  wordBreak: "break-word",
  overflowWrap: "break-word",
}));

export const StyledDashboardCount = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography["5xl"].fontSize,
  fontWeight: theme.typography.fontWeight.bold,
}));

export const StyledDashboardFooter = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 4,
});

export const StyledDashboardChangeText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.extraSmall.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
}));
export const StyledArrowUpwardIcon = styled(ArrowUpwardIcon)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
}));

export const StyledBox = styled(Box)(({theme}) => ({
  display:"flex",
  gap: "15px",
}));